import React from 'react';

import { Modal } from 'src/components/common';
import { DashboardYTDFinancialReportForm } from 'src/components/dashboard';
import { useModalV2 } from 'src/hooks/shared';
import { ModalV2Props } from 'src/types/modalV2';

export const DashboardYTDFinancialReportModal: React.FC<ModalV2Props<unknown>> = ({ id }) => {
  const { closeModal, switchClosability } = useModalV2();

  const handleCloseModal = React.useCallback(() => {
    closeModal(id);
  }, [closeModal, id]);

  return (
    <Modal
      title="Generate Financial Report"
      dialogProps={{
        onClose: handleCloseModal,
        open: true,
      }}
      maxWidth={640}
    >
      <DashboardYTDFinancialReportForm
        onCloseModal={handleCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
